<template>
  <form>
    <div class="row">
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("Dnumber", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            type="text"
            name="drawNumber"
            v-model="createData.drawNumber"
            class="form-control"
            :placeholder="t('Dnumber', {}, { locale: getLocal })"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("Ddate", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            type="date"
            name="drawDate"
            v-model="createData.drawDate"
            class="form-control"
            :placeholder="t('Ddate', {}, { locale: getLocal })"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 p-2">
        {{ t("adddraw", {}, { locale: getLocal }) }}
      </div>
      <div class="col-12 p-2">
        <input
          type="file"
          id="background"
          @change="options.onFileChange"
          name="imageMulti"
          multiple
          accept="image/*"
        />
      </div>

      <div class="col-12 mt-2">
        <img class="w-100" :src="createData.IMAGESRC" alt="" />
      </div>
    </div>

    <div class="button-group d-flex pt-25">
      <button
        @click="options.sendCreateData"
        class="btn btn-primary btn-default btn-squared text-capitalize"
      >
        {{ t("adddraw", {}, { locale: getLocal }) }}
      </button>
    </div>
  </form>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "FormAddDrawListLottery",
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data: function () {
    return {};
  },
  props: ["options", "createData"],
  computed: {
    getLocal: function () {
      return this.$store.getters["display/getLocal"];
    },
  },
};
</script>

<style>
</style>